export default __webpack_public_path__ + "20daf02e53229db93d52ec0303c171b8.svg";